export enum UserSettingsPages {
    GENERAL = "general",
    SECURITY = "security",
    NOTIFICATIONS = "notifications",
    MCP_CLI = "mcp-cli",
}

export enum OrganizationSettingsPages {
    FIRM_INFORMATION = "firm-information",
    TASK_GROUPS = "task-groups",
    SERVICES = "services",
    CLOSE_STAGES = "close-stages",
    CLOSES = "closes",
}

export enum WorkspaceSettingsPages {
    INTEGRATIONS = "integrations",
    MEMBERS = "members",
    TASK_GROUPS = "task-groups",
    LOCKS = "locks",
    ACCOUNTING = "accounting",
    BILLING = "billing",
    PLANS = "plans",
    BILLING_TRANSFER = "billing-transfer",
    DOCUMENT_INBOX = "document-inbox",
    SENDING_DOMAINS = "sending-domains",
}

export enum EntitySettingsPages {
    SETTINGS = "settings",
}

export const DOCUMENT_INBOX_SETTINGS_PATH_ALIASES: Record<string, string> = {
    receipts: WorkspaceSettingsPages.DOCUMENT_INBOX,
    "workspace-receipts": WorkspaceSettingsPages.DOCUMENT_INBOX,
};

export function resolveSettingsPathSegment(segment: string): string {
    return DOCUMENT_INBOX_SETTINGS_PATH_ALIASES[segment] ?? segment;
}
